import { Box, Button, Grid, Pagination, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProfileCard from "../components/Profile/ProfileCard";
import Layout from "../assets/Layout";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import BrowseCoachSidebar from "../components/Candidate/BrowseCoachSidebar";
import { useDispatch } from "react-redux";
import { getUsersByProfile } from "../actions/userAuth";

const BrowseCoaches = () => {
    const [coaches, setCoaches] = useState([]);
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUsersByProfile({ role: "COACH" }, (data) => {
            setCoaches(data.data.data);
        }));
    }, []);
    return (
        <>
            <Layout>
                <Box mt={12}>
                    <Button
                        className='text2Mid'
                        sx={{
                            py: 0.5,
                            px: 2,
                            mx: 1,
                            backgroundColor: '#F7FAFF',
                            borderRadius: '0.5rem',
                            color: '#2544EE',
                            border: '1px solid #2544EE',
                            '&:hover': {
                                color: '#fff',
                                backgroundColor: '#2544EE'
                            },
                            ...(theme.breakpoints.down('md') && {
                                my: 2, // Apply vertical margin for mobile view
                                mx: 3
                            }),
                        }}
                        startIcon={<ArrowBackIosIcon />}
                        onClick={() => navigate('/candidate/dashboard')}
                        variant="contained"
                    >
                        Go Back
                    </Button>
                </Box>
                <Grid container >
                    <Grid item xs={12} md={3} mt={4}>
                        <BrowseCoachSidebar />
                    </Grid>
                    <Grid item xs={12} md={9} mt={4}>
                        <Grid container spacing={4}>
                            <Grid item md={6} mb={5}>
                                <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', mx: 2 }}>Showing 2150 Coaches</Typography>
                                <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', mx: 2, textAlign: 'end' }}>Sort By</Typography>
                            </Grid>
                            <Grid item md={6} mb={5}>
                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6', color: '#061C3D', width: '12rem', borderRadius: '10px', padding: '15px 12px', border: 'none' }}
                                >
                                    <option disabled value="">
                                        Sort by date
                                    </option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>

                                <select
                                    style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6', color: '#061C3D', width: '12rem', borderRadius: '10px', padding: '15px 12px', border: 'none' }}
                                >
                                    <option disabled value="">
                                        Show 10
                                    </option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </Grid>
                            {
                                coaches && coaches.length > 0
                                    ?
                                    coaches.map((item, index) => (
                                        <Grid item xs={12} md={4} key={index} mb={5}>
                                            <ProfileCard coach={item} />
                                        </Grid>
                                    ))
                                    :
                                    <Grid item xs={12} md={4} mb={5}>
                                        <Typography align="center">No Coaches found</Typography>
                                    </Grid>
                            }
                        </Grid>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Pagination count={10} color="primary" shape="rounded" />
                        </Box>
                    </Grid>
                </Grid>
            </Layout>
        </>
    )
}

export default BrowseCoaches;